import React from 'react';
import './ButtonHeadless.css';

interface ButtonHeadlessProps {
  children: React.ReactNode;
  heightStyle?: string;
  paddingYStyle?: string;
  bgStyle?: string;
  borderStyle?: string;
  type?: 'reset' | 'button' | 'submit';
  borderRadiusStyle?: string;
  isDisabled?: boolean;
  action?: React.MouseEventHandler<HTMLButtonElement>;
  opacityOnHover?: boolean;
  shimmer?: boolean;

}

const ButtonHeadless: React.FC<ButtonHeadlessProps> = ({
  children,
  heightStyle = 'h-full',
  paddingYStyle = 'py-3',
  bgStyle = 'bg-primary dark:bg-primary-dark',
  borderStyle = 'border-2 dark:border-transparent',
  borderRadiusStyle = 'rounded-lg',
  type = 'button',
  isDisabled = false,
  opacityOnHover = true,
  action,
  shimmer,

}) => {
  return (
    <button
      className={`${shimmer && "btn-shimmer relative overflow-hidden"
        } w-full flex justify-center items-center focus-visible:outline-none ${!isDisabled && opacityOnHover && 'hover:opacity-80 active:opacity-100'
        } ${heightStyle} ${paddingYStyle} ${bgStyle} ${borderStyle} ${borderRadiusStyle}`}
      type={type}
      onClick={action}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
};

export default ButtonHeadless;
